<script>
/**
 * Descripción: componente Footer
 *
 * @displayName TheFooter
 */

export default {
  name: 'TheFooter'
};
</script>

<template>
  <!-- @ Footer -->
  <v-footer class="pa-8">
    <v-spacer></v-spacer>
    <!-- <div>&copy; {{ new Date().getFullYear() }}</div> -->
  </v-footer>
</template>
